var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRagAppIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5L2 13.5L7 10.5L12 13.5V19L7 22V16.5Z",
    stroke: "#0066CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.5V19L7 22",
    stroke: "#0066CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 16.5446L11.999 13.5146",
    stroke: "#0066CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.53L17 10.5",
    stroke: "#0066CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5V8L7 5L12 2L17 5V10.5",
    stroke: "#0066CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.03027V10.4853",
    stroke: "#0066CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L17 5",
    stroke: "#0066CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.459 21.34C21.432 21.3887 21.3931 21.4291 21.3463 21.4572C21.2995 21.4852 21.2464 21.5 21.1924 21.5H13.8074C13.7534 21.4999 13.7004 21.4851 13.6536 21.457C13.6069 21.4289 13.5681 21.3885 13.5411 21.3399C13.5142 21.2912 13.5 21.2361 13.5 21.18C13.5 21.1238 13.5142 21.0687 13.5412 21.0201C14.127 19.967 15.0298 19.2119 16.0833 18.854C15.5622 18.5314 15.1573 18.0399 14.9308 17.4549C14.7044 16.8699 14.6689 16.2238 14.8297 15.6157C14.9906 15.0077 15.339 14.4714 15.8214 14.0892C16.3037 13.707 16.8934 13.5 17.4999 13.5C18.1064 13.5 18.6961 13.707 19.1784 14.0892C19.6608 14.4714 20.0092 15.0077 20.1701 15.6157C20.3309 16.2238 20.2954 16.8699 20.069 17.4549C19.8425 18.0399 19.4376 18.5314 18.9165 18.854C19.97 19.2119 20.8728 19.967 21.4586 21.0201C21.4856 21.0687 21.4999 21.1238 21.5 21.18C21.5001 21.2362 21.4859 21.2913 21.459 21.34Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRagAppIcon);
export default __webpack_public_path__ + "static/media/ragAppIcon.f332670950b22bd8d47152231cd6f4b8.svg";
export { ForwardRef as ReactComponent };